import { render, staticRenderFns } from "./JudgeStudentView.vue?vue&type=template&id=236aa958&scoped=true&"
import script from "./JudgeStudentView.vue?vue&type=script&lang=js&"
export * from "./JudgeStudentView.vue?vue&type=script&lang=js&"
import style0 from "./JudgeStudentView.vue?vue&type=style&index=0&id=236aa958&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236aa958",
  null
  
)

export default component.exports